export class TimeZoneInfo {
  Id: string;
  name: string;
  baseUtcOffset: string;
  standardName: string;
  daylightName: string;
  supportsDaylightSavingsTime: boolean;
  DisplayName: string;
}
